import React, { useState, useEffect } from "react"

import PymeItem from "./PymeItem"

const PymesSection = ({ pymes, limit = 0, isSearch = false, plan }) => {
  const [data, setData] = useState([])
  const [showAll, setShowAll] = useState(false)

  useEffect(() => {
    if (pymes && pymes.length > 0) {
      if (limit !== 0 && pymes.length > limit) {
        const filter = pymes.slice(0, limit)
        setData(filter)
      } else {
        const datas = [...pymes]
        setData(datas)
      }
    }
  }, [pymes, limit])

  const toggleShow = () => {
    setShowAll(!showAll)
  }

  return (
    <div>
      {isSearch ? (
        <section className="grid grid-cols-2 gap-4 justify-center mb-18 md:grid-cols-5">
          {!showAll &&
            data.length > 0 &&
            data.map(node => <PymeItem key={node.name} node={node} />)}
          {showAll &&
            pymes.length > 0 &&
            pymes.map(node => <PymeItem key={node.name} node={node} />)}
        </section>
      ) : (
        <section className="grid grid-cols-2 gap-4 justify-center mb-24 md:grid-cols-5">
          {!showAll &&
            data.length > 0 &&
            data.map(({ node }) => <PymeItem key={node.name} node={node} />)}
          {showAll &&
            pymes.length > 0 &&
            pymes.map(({ node }) => <PymeItem key={node.name} node={node} />)}
        </section>
      )}

      {limit !== 0 && pymes.length > limit && (
        <button
          type="button"
          className="rounded-lg shadow-lg block mx-auto bg-pink-500 p-4 text-white mb-8"
          onClick={toggleShow}
        >
          {showAll ? "VER MENOS PYMES" : "VER TODAS LAS PYMES"}
        </button>
      )}
    </div>
  )
}

export default PymesSection
